
import moment from "moment"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { MdKeyboardArrowRight } from "react-icons/md";
import Pagination from "../shared/Pagination"
import { getAllPanelNotificationHistory, getSpecificPanelNotificationHistory, setNotificationActiveTabPortal, setNotificationHistoryItemToFilledPortal, setNotificationHistoryItemToFilledSpecificPortal } from "../../features/admin4/admin4Slice";
import { toast } from "react-toastify";
import { scrollToTop } from "../../helper/scrollToTop";
import { mainMenuOptions } from "../../utils/portalBildirimOptions"

const Container = styled.div`
    width: 100%;
    padding: 30px;

    .content-container{
        display: flex;
        justify-content: space-between;
        gap: 40px;


        .content-side{
            width: calc(50% - 20px);
            background-color: ${({theme}) => theme.secondaryBgColor};
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 10px;
            padding: 20px;
            gap: 20px;
            color: ${({theme}) => theme.mainTextColor};


            .side-top{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }

            .notification-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 100%;

                .date-grp-container{
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .date{
                        width: 100%;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                        padding-bottom: 5px;
                        margin-bottom: 10px;
                    }

                    .list{
                        display: flex;
                        flex-direction: column;
                        gap: 20px;

                        .list-item{
                            display: flex;
                            flex-direction: column;
                            gap: 10px;
                            width: 100%;
                            padding-bottom: 20px;
                            border-bottom: 1px solid ${({theme}) => theme.mainBgColor};

                            .list-item-part{
                                display: flex;
                                justify-content: space-between !important;
                                align-items: center;

                                &:first-child{

                                }

                                .list-item-part-grp{
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                font-size: var(--font-size-sm);
                                
                                .key{
                                    font-weight: var(--font-weight-lg);
                                    display: flex;
                                    align-items: center;
                                    gap: 5px;

                                    .arr-icon{
                                        font-size: 1.2rem;
                                    }
                                }

                                .value{
                                    font-weight: var(--font-weight-md);
                                }

                                .btn{
                                    border: 1px solid var(--color-main);
                                    padding: 5px 10px;
                                    border-radius: 5px;
                                    color: var(--color-main);
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-xl);
                                }
                                }
                            }

                            .company-name-container{
                                display: flex;
                                flex-wrap: wrap;
                                gap: 10px;

                                .company-name-item{
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-lg);
                                }
                            }
                        }
                    }

                }


            }
        }
    }
`

const PortalNotificationHistory = () => {

    const {

        allPanelNotificationHistoryCount,
        isLoadingGetAllPanelNotificationHistory,
        allPanelNotificationHistoryList,
        
        
        specificPanelNotificationHistoryCount,
        isLoadingGetSpecificPanelNotificationHistory,
        specificPanelNotificationHistoryList,

    } = useSelector(state => state.admin4)
    
    const [showNumberClickIndex, setShowNumberClickIndex] = useState(null)

    const dispatch = useDispatch()

    const [currentPageAll, setCurrentPageAll] = useState(1)
    const [currentPageSpecific, setCurrentPageSpecific] = useState(1)

    const itemsPerPage = 50;
    const totalPagesAll = Math.ceil(allPanelNotificationHistoryCount / itemsPerPage);
    const totalPagesSpecific = Math.ceil(specificPanelNotificationHistoryCount / itemsPerPage);

    useEffect(() => {
    dispatch(getAllPanelNotificationHistory({page:currentPageAll}))
    dispatch(getSpecificPanelNotificationHistory({page:currentPageSpecific}))

    },[currentPageAll, currentPageSpecific])


    const handleNotificationHistoryItemToFilled = (historyItem, type) => {

        const notificationTitlePortal = historyItem?.messageTitle
        const notificationTextPortal = historyItem?.messageText

        const notificationMenuPortal = mainMenuOptions.find(menuItem => {
            return menuItem.value === historyItem?.menuName
        })
        const notificationSubMenuPortal = mainMenuOptions.find(item => {
            return item?.value === historyItem?.menuName
        })?.subMenus?.find(item => {
            return item?.value === historyItem?.subMenuName
        }) || {
            id: "",
            text: "",
            value: ""
          }

        if(type === "all"){

            dispatch(setNotificationActiveTabPortal(1))
            dispatch(setNotificationHistoryItemToFilledPortal({
                notificationTitlePortal,
                notificationTextPortal,
                notificationMenuPortal,
                notificationSubMenuPortal
            }))
        }

        else{
            dispatch(setNotificationActiveTabPortal(2))
            dispatch(setNotificationHistoryItemToFilledSpecificPortal({
                notificationTitlePortal,
                notificationTextPortal,
                notificationMenuPortal,
                notificationSubMenuPortal,
                selectedCompanyList: historyItem.notificationRecipients.$values.map(item => {
                    return{
                        companyName: item.companyName,
                        companyId: item.companyId
                    }
                })
            }))
        }

        toast.success('Bildirim verileri inputlara başarılı bir şekilde aktarıldı.', {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }


  return (
    <Container>
        <div className="content-container">

            <div className="content-side">
                <div className="side-top">Herkese Gönderilen Bildirim Geçmişi</div>

                <div className="notification-list">

                    {
                        allPanelNotificationHistoryList.map((item) => (
                            <div className="date-grp-container">
                                <div className="date">{moment(item.createdAt).format("L")}</div>
                                <div className="list">
                                    {
                                        item.data.map((historyItem) =>(
                                            <div className='list-item'>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderilme Tarihi:</div>
                                                        <div className="value">{moment(item.createdAt).format("HH:mm")}</div>
                                                    </div>
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderen Kullanıcı:</div>
                                                        <div className="value">{historyItem.createrUserName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key"> Menu:</div>
                                                        <div className="value">{historyItem.menuName}</div>
                                                    </div>
                                                
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Alt Menü:</div>
                                                        <div className="value">{historyItem.subMenuName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Başlığı:</div>
                                                        <div className="value">{historyItem.messageTitle}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Metni:</div>
                                                        <div className="value">{historyItem.messageText}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <button className="btn" onClick={() => {handleNotificationHistoryItemToFilled(historyItem, "all"); scrollToTop(200)}}>Bu Bildirimi Tekrarla</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>

                {(allPanelNotificationHistoryList || allPanelNotificationHistoryList?.length > 0) && (
                    <Pagination
                    totalPages={totalPagesAll}
                    handleClick={setCurrentPageAll}
                    currentPage={currentPageAll}
                    />
                )}
            </div>

            <div className="content-side">
                <div className="side-top">Firma İsmine Göre Gönderilen Bildirim Geçmişi</div>

                <div className="notification-list">
                    {
                        specificPanelNotificationHistoryList.map((item) => (
                            <div className="date-grp-container">
                                <div className="date">{moment(item.createdAt).format("L")}</div>
                                <div className="list">
                                    {
                                        item.data.map((historyItem) =>(
                                            <div className='list-item'>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderilme Tarihi:</div>
                                                        <div className="value">{moment(item?.createdAt).format("HH:mm")}</div>
                                                    </div>
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderen Kullanıcı:</div>
                                                        <div className="value">{historyItem?.createrUserName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key"> Menu:</div>
                                                        <div className="value">{historyItem?.menuName}</div>
                                                    </div>
                                                
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Alt Menü:</div>
                                                        <div className="value">{historyItem?.subMenuName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Başlığı:</div>
                                                        <div className="value">{historyItem?.messageTitle}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Metni:</div>
                                                        <div className="value">{historyItem?.messageText}</div>
                                                    </div>
                                                </div>


                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp" style={{cursor: "pointer"}}>
                                                        <div className="key" onClick={() => setShowNumberClickIndex(showNumberClickIndex === historyItem.id ? null : historyItem.id)} style={{textDecoration: "underline"}}>Gönderilen Numaralar <MdKeyboardArrowRight className="arr-icon"/></div>
                                                        <div className="value"></div>
                                                    </div>
                                                </div>
                                                {
                                                    showNumberClickIndex === historyItem.id &&
                                                    <div className="company-name-container">
                                                        {
                                                            historyItem.notificationRecipients.$values.map(item => (
                                                                <div className="company-name-item">{item.companyName}</div>
                                                            ))
                                                        }
                                                    </div>
                                                }
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <button className="btn" onClick={() => {handleNotificationHistoryItemToFilled(historyItem, "specific"); scrollToTop(200)}}>Bu Bildirimi Tekrarla</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>

                {(specificPanelNotificationHistoryList || specificPanelNotificationHistoryList?.length > 0) && (
                    <Pagination
                    totalPages={totalPagesSpecific}
                    handleClick={setCurrentPageSpecific}
                    currentPage={currentPageSpecific}
                    />
                )}
            </div>

        </div>

    </Container>
  )
}

export default PortalNotificationHistory